import { PaymentDueAccountVM, PaymentMethodVM } from "@propertelligent/client-api";
import { useState } from "react";
import "./payment.css";
import PaymentSummaryTotalAmount from "./PaymentSummaryTotalAmount";
import H3 from "../typography/H3";
import H5 from "../typography/H5";
import SelectField from "../form-fields/SelectField";
import InputField from "../form-fields/InputField";
import EmptyState from "../emptystate";
import PaymentIcon from "../../assets/Payment-Icon.svg";
import { GetImages } from "../../utils/GetImages";
import { formatWithCommas } from "../../utils/helper";
import UtilHelper from "../../utils/UtilHelper";
interface PaymentSummaryProps {
  totalAmount: string;
  paymentMethods: PaymentMethodVM[];
  Payments: PaymentDueAccountVM[];
}

export default function PaymentSummary({
  totalAmount,
  paymentMethods,
  Payments
}: PaymentSummaryProps) {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>(null);

  const handlePaymentMethodChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const method = paymentMethods.find(x => x.id === Number(e.target.value))?.accountName || '';
    setSelectedPaymentMethod(method);
  };

  const paymentMethodOptions = paymentMethods.map((method) => ({
    Id: method.id,
    Name: method.accountName
  }));

  return (
    <div className="main-container main-container-payment">
      <div className="header-section">
        <H3 text="Payment Summary" />
      </div>
      {Payments.length > 0 ? (
        <>
          <PaymentSummaryTotalAmount label="You've Paid" amount={totalAmount} />

          <div className="mx-4 my-3">
            <H5 text="Choose Payment Method" />

            <div className="row mt-3 flex-column">
              <div className="col-md-6 mb-1">
                <SelectField
                  placeholderText="Select Payment Mode"
                  name="PaymentModeId"
                  label="Payment Mode"
                  required
                  requiredMessage="Select Payment Mode is required"
                  options={paymentMethodOptions}
                  onChange={handlePaymentMethodChange}
                />
              </div>

              {selectedPaymentMethod === "Check" ? (
                <div className="col-md-6 mb-1">
                  <InputField
                    name="checkNum"
                    label="Check No"
                    placeholder="Enter Check No"
                    type="text"
                    required
                    requiredMessage="Check No is required"
                  />
                </div>
              ) : (selectedPaymentMethod && selectedPaymentMethod !== "Cash") && (
                <div className="col-md-6 mb-1">
                  <InputField
                    name="transactionId"
                    label="Transaction ID"
                    placeholder="Enter Transaction ID"
                    type="text"
                    required
                    requiredMessage="Transaction ID is required"
                  />
                </div>
              )}

              <div className="col-md-6 mb-1">
                <InputField
                  name="date"
                  label="Payment Date"
                  type="date"
                  required
                  requiredMessage="Payment Date is required"
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <EmptyState
          icon={GetImages.emptyStatePayment}
          heading="No Payment Selected"
          isButton={false}
          className="empty-state-wrapper"
        />
      )
      }
    </div>
  );
}